import React from 'react';
const bonuses = [{
  number: '01',
  title: 'Kit Exprés Sensorial',
  description: 'Actividades listas para aplicar en segundos cuando necesitas una intervención rápida. Tu salvavidas de sesión.',
  value: '$14.999',
  image: 'https://cdn.magicpatterns.com/uploads/bjVGAnqE7WexmkimR8MM4L/20260302_1436_Image_Generation_remix_01kjqswn6gf73t180ycr6f9cac.png'
}, {
  number: '02',
  title: 'Ficha Perfil Editable',
  description: 'Plantilla digital editable para registrar el perfil sensorial de cada niño. Tu historial clínico organizado en minutos.',
  value: '$9.999',
  image: 'https://cdn.magicpatterns.com/uploads/onYMiFVuRfYMhASCUpLN4H/20260302_1509_Ficha_Perfil_Editable_remix_01kjqvra1xefwr789vwdvwzr4r.png'
}, {
  number: '03',
  title: 'Guía Lúdica Terapéutica',
  description: 'Estrategias graduadas para usar el juego como vehículo clínico que captura la atención y sostiene la sesión.',
  value: '$12.999',
  image: 'https://cdn.magicpatterns.com/uploads/2JDShoztA4CLMV3GPygkfe/20260302_1512_Image_Generation_remix_01kjqvz0vwed6t4ncng4m85jff.png'
}, {
  number: '04',
  title: 'Protocolo Anticrisis Express',
  description: 'Pasos concretos para los momentos más difíciles. Cuando el niño entra en crisis, tú ya sabes exactamente qué hacer.',
  value: '$14.999',
  image: 'https://cdn.magicpatterns.com/uploads/vWSxWvLUQYoxtxiQS3q1L5/20260302_1452_Image_Generation_remix_01kjqtry7ye84tb7zvatvenknm.png'
}, {
  number: '05',
  title: 'Ruta Express 7 Días',
  description: 'Implementación paso a paso para que en solo 7 días tengas las herramientas integradas en tu práctica clínica diaria.',
  value: '$9.999',
  image: 'https://cdn.magicpatterns.com/uploads/vr4gD4AxvLrxAAN4aUADmc/20260302_1501_Image_Generation_remix_01kjqvbfzaenjbr1x521sctpgp.png'
}, {
  number: '06',
  title: 'Comunidad WhatsApp',
  description: 'Acceso a nuestra comunidad exclusiva de WhatsApp con contenido exclusivo, soporte y acompañamiento continuo. Beneficios exclusivos para ti.',
  value: '',
  image: 'https://cdn.magicpatterns.com/uploads/sqvLrxZpQMzYMpbEiwxxv4/20260302_1538_Image_Generation_remix_01kjqxeg9yfz7a7xagzsmtxcy6.png'
}];

// Resaltado visual SIN reescribir: solo envuelve partes exactas del string
function renderDescriptionExact(desc) {
  // Ojo: no cambiamos el texto; solo lo "partimos" para resaltar.
  // Si no matchea, devolvemos desc tal cual.
  const rules = [{
    key: 'Actividades listas para aplicar en segundos',
    mode: 'boldUnderline'
  }, {
    key: 'intervención rápida',
    mode: 'italic'
  }, {
    key: 'Tu salvavidas de sesión',
    mode: 'bold'
  }, {
    key: 'Plantilla digital editable',
    mode: 'boldUnderline'
  }, {
    key: 'perfil sensorial',
    mode: 'underline'
  }, {
    key: 'organizado en minutos',
    mode: 'bold'
  }, {
    key: 'usar el juego',
    mode: 'boldUnderline'
  }, {
    key: 'captura la atención',
    mode: 'bold'
  }, {
    key: 'sostiene la sesión',
    mode: 'underline'
  }, {
    key: 'Pasos concretos',
    mode: 'boldUnderline'
  }, {
    key: 'momentos más difíciles',
    mode: 'italic'
  }, {
    key: 'exactamente qué hacer',
    mode: 'bold'
  }, {
    key: 'paso a paso',
    mode: 'boldUnderline'
  }, {
    key: 'en solo 7 días',
    mode: 'bold'
  }, {
    key: 'práctica clínica diaria',
    mode: 'underline'
  }, {
    key: 'comunidad exclusiva de WhatsApp',
    mode: 'boldUnderline'
  }, {
    key: 'soporte y acompañamiento continuo',
    mode: 'bold'
  }, {
    key: 'Beneficios exclusivos para ti',
    mode: 'underline'
  }];

  // Aplicamos la PRIMER regla que matchee de forma segura, y luego intentamos aplicar más reglas
  // de manera incremental SIN romper el texto.
  let parts = [desc];
  for (const r of rules) {
    parts = parts.flatMap(p => {
      if (typeof p !== 'string') return [p];
      const idx = p.indexOf(r.key);
      if (idx === -1) return [p];
      const before = p.slice(0, idx);
      const match = p.slice(idx, idx + r.key.length);
      const after = p.slice(idx + r.key.length);
      const cls = r.mode === 'boldUnderline' ? 'font-semibold underline underline-offset-4 decoration-2' : r.mode === 'bold' ? 'font-semibold' : r.mode === 'underline' ? 'underline underline-offset-4 decoration-2' : 'italic';
      return [before, <span key={`${r.key}-${idx}`} className={cls} data-id="element-15">
          {match}
        </span>, after];
    });
  }
  return <>{parts}</>;
}
export function BonusSection() {
  return <section className="bg-brand-mint py-16 md:py-20 px-6" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        {/* Eyebrow */}
        <p className="font-display font-extrabold tracking-[0.22em] uppercase text-brand-green mb-3 text-[13px] md:text-[14px]" data-id="element-18">
          Incluidos con tu compra hoy
        </p>

        {/* Headline */}
        <h2 className="font-display font-black uppercase text-brand-ink leading-[1.05] mb-4 text-[34px] md:text-5xl" data-id="element-19">
          6 Bonos Exclusivos — Gratis
        </h2>

        {/* Subheadline (mismo copy, mejor legibilidad) */}
        <p className="text-gray-600 mb-10 text-[15px] md:text-base leading-relaxed max-w-3xl" data-id="element-20">
          <span className="font-semibold" data-id="element-21">Si compras hoy</span>, recibes estos{' '}
          <span className="underline underline-offset-4 decoration-2" data-id="element-22">
            6 recursos
          </span>{' '}
          de forma completamente <em className="italic" data-id="element-23">gratuita</em>. Son
          productos individuales con <span className="font-semibold" data-id="element-24">valor real</span> — te los regalo
          para que tus resultados sean{' '}
          <span className="font-semibold underline underline-offset-4 decoration-2" data-id="element-25">
            visibles desde la primera sesión
          </span>
          .
        </p>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-26">
          {bonuses.map((bonus, index) => <article key={index} className="bg-white rounded-2xl overflow-hidden border border-gray-200 hover:border-brand-green transition-all duration-200 hover:-translate-y-1 shadow-sm" data-id="element-27">
              {/* Top bar / badges */}
              <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100" data-id="element-28">
                <div className="flex items-center gap-2" data-id="element-29">
                  <span className="inline-flex items-center rounded-full bg-brand-mint px-3 py-1 text-[12px] font-display font-extrabold tracking-[0.15em] uppercase text-brand-green" data-id="element-30">
                    Bono {bonus.number}
                  </span>
                  <span className="inline-flex items-center rounded-full bg-brand-green px-3 py-1 text-[12px] font-display font-extrabold tracking-[0.12em] uppercase text-white" data-id="element-31">
                    GRATIS
                  </span>
                </div>

                {bonus.value ? <div className="text-right leading-tight" data-id="element-32">
                    <div className="text-[11px] uppercase tracking-wider text-gray-500 font-display font-bold" data-id="element-33">
                      Valor
                    </div>
                    <div className="text-gray-500 line-through text-[14px] font-display font-bold" data-id="element-34">
                      {bonus.value}
                    </div>
                  </div> : <div className="text-right leading-tight" data-id="element-35">
                    <div className="text-[11px] uppercase tracking-wider text-gray-500 font-display font-bold" data-id="element-36">
                      Incluido
                    </div>
                    <div className="text-brand-green-dark font-display font-extrabold text-[14px]" data-id="element-37">
                      ✓ GRATIS
                    </div>
                  </div>}
              </div>

              {/* Mockup image */}
              <div className="w-full flex justify-center items-center bg-gray-50 py-8 px-4" data-id="element-38">
                <img src={bonus.image} alt={bonus.title} className="h-64 md:h-80 w-auto object-contain drop-shadow-lg" loading="lazy" data-id="element-39" />
              </div>

              {/* Content */}
              <div className="p-6 md:p-7" data-id="element-40">
                <h3 className="font-display font-extrabold uppercase text-brand-ink leading-tight mb-3 text-[18px] md:text-[20px]" data-id="element-41">
                  {bonus.title}
                </h3>

                {/* Descripción con resaltado visual (sin reescritura) */}
                <p className="text-[14px] md:text-[14.5px] text-gray-700 leading-relaxed mb-5" data-id="element-42">
                  {renderDescriptionExact(bonus.description)}
                </p>

                {/* Footer: “✓ GRATIS” más visible */}
                <div className="flex items-center justify-between gap-3 pt-4 border-t border-gray-100" data-id="element-43">
                  <p className="font-display font-extrabold text-brand-green-dark text-[14px] md:text-[15px]" data-id="element-44">
                    ✓ GRATIS
                  </p>
                  {bonus.value ? <p className="text-[12px] md:text-[12.5px] text-gray-500" data-id="element-45">
                      <span className="font-semibold" data-id="element-46">Antes:</span>{' '}
                      <span className="line-through" data-id="element-47">{bonus.value}</span>
                    </p> : <p className="text-[12px] md:text-[12.5px] text-gray-500" data-id="element-48">
                      <span className="font-semibold" data-id="element-49">Acceso:</span> incluido
                    </p>}
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}